// extracted by mini-css-extract-plugin
export var circle = "ChatBotComponent-module--circle--dc733";
export var fab = "ChatBotComponent-module--fab--0d791";